module.exports = __webpack_public_path__ + "img/inkpptLogo.daea4403.svg";